import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import SupportFooter from "../components/SupportFooter";
import { Container, FooterSection, HeaderSection, Heading, Text } from "../styledcomponents";
import { ReactComponent as CheckMark } from "../assets/images/checkmark.svg";
import LangDropdownOptions from "../components/LangDropdownOptions";
import styled from "styled-components";

const SuccessScreen = () => {
  const [searchParams] = useSearchParams();

  const { t, i18n } = useTranslation();
  const languageParam = searchParams.get("lang");

  useEffect(() => {
    if (languageParam) {
      i18n.changeLanguage(languageParam);
    }
  }, [i18n, languageParam]);

  return (
    <>
      <Container>
        <StyledCheckMark />

        <HeaderSection>
          <Heading>{t("success.heading")}</Heading>
          <Text>{t("success.message")}</Text>
        </HeaderSection>
      </Container>
      <FooterSection>
        <SupportFooter />
        <LangDropdownOptions />
      </FooterSection>
    </>
  );
};

export default SuccessScreen;

const StyledCheckMark = styled(CheckMark)`
  margin: 0 auto 16px auto;
`;
